import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { CalendarIcon, XIcon } from '@heroicons/react/outline';
import dayjs from 'dayjs';
import './styles.css';

export default function CustomDateRangePicker({ value, onChange }) {
	const minDate = dayjs().subtract(3, 'month').toDate();
	const maxDate = new Date();

	const handleDateChange = (newValue) => {
		if (newValue === null) {
			onChange([new Date(), new Date()]);
		} else {
			onChange(newValue);
		}
	};

	return (
		<div className="appmaker-date-range-picker">
			<DateRangePicker
				onChange={handleDateChange}
				value={value}
				format="MMM dd, yyyy"
				clearIcon={<XIcon className="w-4 h-4" />}
				calendarIcon={<CalendarIcon className="w-4 h-4" />}
				className="border border-gray-300 rounded-md"
				minDate={minDate}
				maxDate={maxDate}
			/>
		</div>
	);
}
